import React from "react";
import "../../Css/HomePage/HomeRoom.css";
import { HiOutlineUserCircle } from "react-icons/hi2";
import { BiArea } from "react-icons/bi";
import { MdOutlineFreeBreakfast } from "react-icons/md";
import deluxe_room_01 from "../../Images/Deluxe-Room/Deluxe-Room.jpg";
import RoomData from "../RoomData";
import { NavLink } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';

// Import Swiper styles correctly
import 'swiper/css'; // Main styles
import 'swiper/css/navigation'; // For navigation styles (optional)
import 'swiper/css/pagination'; // For pagination styles (optional)
import { Zoom } from "react-awesome-reveal";
const HomeRoom = (() => {
    return (
        <>
         
            <section className="container-fluid home-section-room">
                <div className="container">
                    <div className="home-section-room-head-main-con">
                        <h2>Our Rooms</h2>
                        <h3>Our Rooms</h3>
                    </div>
                    <div className="home-section-room-main-con">
                    <Swiper
                          modules={[Navigation, Pagination, Scrollbar, A11y]}

        spaceBetween={20} // Space between slides
        // slidesPerView={3} // Display 3 slides at a time
        navigation={true} // Add navigation buttons (optional)
        loop // Enable looping (optional)
        breakpoints={{
            320: {
                slidesPerView: 1, // 1 slide per view on mobile devices
              },
              480: {
                slidesPerView: 1, // 1 slide per view on small tablets
              },
              768: {
                slidesPerView: 1, // 1 slide per view on larger tablets
              },
              1024: {
                slidesPerView: 2, // 2 slides per view on desktop and larger devices
              },
        }}
      >
        {/* Example slides */}
        {/* <SwiperSlide>
          <div className="slide-content">Slide 1</div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slide-content">Slide 2</div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slide-content">Slide 3</div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slide-content">Slide 4</div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slide-content">Slide 5</div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slide-content">Slide 6</div>
        </SwiperSlide>
       */}
                        <div className="row">
                            {
                                RoomData.map((elem) => {
                                    return (
                                        <>
                                            {/* <div className="col-md-6">
                                                <NavLink to={elem.slug}>
                                                <div className="home-section-room-card-body-main-con">
                                                    <div className="home-section-room-card-body">
                                                        <img src={elem.roomImageData[0].roomImage} alt="deluxe_room_01" />
                                                        <div className="home-section-room-card-body-details">
                                                            <h4>{elem.roomName}</h4>
                                                            <div className="home-section-room-card-body-details-icons-name-main-con">
                                                                <div className="home-section-room-card-body-details-icons-name-con">
                                                                    <div className="home-section-rrom-card-overlay-card">
                                                                        <HiOutlineUserCircle />
                                                                        <h5>Guests</h5>
                                                                    </div>
                                                                    <div className="home-section-rrom-card-overlay-card">
                                                                        <BiArea />
                                                                        <h5>Guests</h5>
                                                                    </div>
                                                                    <div className="home-section-rrom-card-overlay-card">
                                                                        <MdOutlineFreeBreakfast />
                                                                        <h5>Breakfast</h5>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="home-section-room-card-body-details-price-main-con">
                                                            <h6>Form ₹ {elem.roomPrice}</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                </NavLink>
                                            </div> */}
                                            <SwiperSlide>
                                                <Zoom direction="out">
                                            <NavLink to={elem.slug}>
                                                <div className="home-section-room-card-body-main-con">
                                                    <div className="home-section-room-card-body">
                                                        <img src={elem.roomImageData[0].roomImage} alt="deluxe_room_01" style={{objectFit:"cover"}}/>
                                                        <div className="home-section-room-card-body-details">
                                                            <h4>{elem.roomName}</h4>
                                                            <div className="home-section-room-card-body-details-icons-name-main-con">
                                                                <div className="home-section-room-card-body-details-icons-name-con">
                                                                    <div className="home-section-rrom-card-overlay-card">
                                                                        <HiOutlineUserCircle />
                                                                        <h5>Guests</h5>
                                                                    </div>
                                                                    <div className="home-section-rrom-card-overlay-card">
                                                                        <BiArea />
                                                                        <h5>Guests</h5>
                                                                    </div>
                                                                    <div className="home-section-rrom-card-overlay-card">
                                                                        <MdOutlineFreeBreakfast />
                                                                        <h5>Breakfast</h5>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="home-section-room-card-body-details-price-main-con">
                                                            <h6>Form ₹ {elem.roomPrice}</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                </NavLink>
                                                </Zoom>
                                                </SwiperSlide>
                                        </>
                                    )
                                })
                            }
                        </div>
                        </Swiper> 
                    </div>
                </div>
            </section>
        </>
    )
});

export default HomeRoom;